import 'es6-promise/auto'
import Vue from 'vue'
import App from './App'
import store from '@/store'
import VueCookie from 'vue-cookie'
import { myPlugin } from '@/utils'
import ElementUI from 'element-ui'
import VueI18n from 'vue-i18n' // 引入国际化包
import enlang from 'element-ui/lib/locale/lang/en'
import zhlang from 'element-ui/lib/locale/lang/zh-CN'
import twlang from 'element-ui/lib/locale/lang/zh-TW'
import locale from 'element-ui/lib/locale'
import zh from './lang/zh'
import en from './lang/en'
import tw from './lang/tw'
import router from './router'
import { VueJsonp } from 'vue-jsonp'
import devTestMixin from './mixins/devTestMixin'
import axios from '@/axios'

Vue.use(VueJsonp)
// 自定义主题
import '@/assets/scss/app.scss'
let R = store.state.userRole
let qq = 800822910
if (R == 4 || R == 5 || /www.jf24k/.test(window.location.origin)) {
  qq = 4006182188
}
Vue.use(ElementUI)
Vue.use(VueCookie)
Vue.use(myPlugin, qq)
Vue.use(VueI18n) // 全局注册国际化包
const i18n = new VueI18n({
  locale: 'zh', //
  messages: {
    en,
    zh,
    tw,
  },
})
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = `${i18n.t('meta.base')}`
  }
  next()
})
// 日历插件国际化设置  繁体中文（zh-TW）  简体中文（zh-CN） 英语（en）
if (i18n.locale === 'en') {
  locale.use(enlang)
} else if (i18n.locale === 'zh') {
  locale.use(zhlang)
} else {
  locale.use(twlang)
}
// locale.i18n((key,value) => i18n.t(key,value))
Vue.config.productionTip = false

Vue.prototype.$axios = axios

//测试
Vue.mixin(devTestMixin)

new Vue({
  el: '#app',
  i18n,
  store,
  router,
  render: h => h(App),
})



// WEBPACK FOOTER //
// ./src/main.js